import { render, staticRenderFns } from "./FullDescription.vue?vue&type=template&id=450355ca"
import script from "./FullDescription.vue?vue&type=script&lang=js"
export * from "./FullDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450355ca')) {
      api.createRecord('450355ca', component.options)
    } else {
      api.reload('450355ca', component.options)
    }
    module.hot.accept("./FullDescription.vue?vue&type=template&id=450355ca", function () {
      api.rerender('450355ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/FullDescription.vue"
export default component.exports